import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid g-2 landingpage__container" }
const _hoisted_2 = { class: "rowv g-2 master__headline" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "row g-2" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row g-2 align-items-center login__content" }
const _hoisted_7 = { class: "col max__width" }
const _hoisted_8 = { class: "input-group space__surround" }
const _hoisted_9 = { class: "input-group space__surround" }
const _hoisted_10 = ["type"]
const _hoisted_11 = {
  class: "input-group-text",
  style: {"background-color":"white"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "header", {}, () => [
          _cache[5] || (_cache[5] = _createElementVNode("p", null, "Anmeldung", -1))
        ], true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col" }, [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            class: "intro__image",
            src: "img/background/intro_logo.svg"
          })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("form", {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.tryLogin()), ["prevent"])),
              class: "form__signin"
            }, [
              _createElementVNode("div", _hoisted_8, [
                _cache[6] || (_cache[6] = _createElementVNode("span", {
                  class: "input-group-text",
                  style: {"background-color":"white","padding":"0.375rem 0.1rem"}
                }, null, -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "userName",
                  class: "form-control",
                  placeholder: "Benutzername",
                  required: "",
                  autocomplete: "off",
                  spellcheck: "false",
                  autocorrect: "off",
                  autocapitalize: "off",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.login.UserName) = $event)),
                  style: {"border-left":"none","border-right":"none"}
                }, null, 512), [
                  [_vModelText, _ctx.login.UserName]
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("span", {
                  class: "input-group-text",
                  style: {"background-color":"white","padding":"0.375rem 0.1rem"}
                }, null, -1))
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[8] || (_cache[8] = _createElementVNode("span", {
                  class: "input-group-text",
                  style: {"background-color":"white","padding":"0.375rem 0.1rem"}
                }, null, -1)),
                _withDirectives(_createElementVNode("input", {
                  type: _ctx.passwordType,
                  id: "userPassword",
                  name: "current-password",
                  class: "form-control",
                  placeholder: "Password",
                  autocomplete: "current-password",
                  required: "",
                  spellcheck: "false",
                  autocorrect: "off",
                  autocapitalize: "off",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.login.Password) = $event)),
                  style: {"border-left":"none","border-right":"none"},
                  onPaste: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
                }, null, 40, _hoisted_10), [
                  [_vModelDynamic, _ctx.login.Password]
                ]),
                _createElementVNode("span", _hoisted_11, [
                  _createElementVNode("i", {
                    class: _normalizeClass(_ctx.passwortClass),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.togglePassword())),
                    style: {"display":"inline-block!important"},
                    id: "togglePassword"
                  }, null, 2)
                ])
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("button", { class: "btn btn-primary login__button space__surround" }, "Login", -1))
            ], 32)
          ])
        ])
      ])
    ]),
    _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"row g-2\" data-v-59c476d8><div class=\"col\" data-v-59c476d8><div data-v-59c476d8><img class=\"intro__image\" src=\"img/background/intro_hosting.svg\" data-v-59c476d8></div></div><div class=\"col\" data-v-59c476d8><div data-v-59c476d8><img class=\"intro__image\" src=\"img/background/intro_modul_uebersicht.svg\" data-v-59c476d8></div></div></div>", 1))
  ]))
}